// extracted by mini-css-extract-plugin
export default {"titular":"CredencialComponent_titular__kozkk","td":"CredencialComponent_td__zDOmx"};